<template>
    <div class="banners-jaksurvei">
      <div class="image-banners" :style="backgroundStyle">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <h5 class="title">Jakarta Survei</h5>
              <p class="desc">Jakarta Survei adalah sebuah wadah bagi masyarakat DKI Jakarta untuk dapat menuangkan penilaian maupun aspirasi mereka melalui pengisian survei terkait layanan, kebijakan, maupun fasilitas yang terdapat di Provinsi DKI Jakarta. Jaksurvei telah terintegrasi dengan aplikasi JAKI (Jakarta Kini) yang dapat dengan mudah diakses oleh siapa saja. Selain itu, JakSurvei juga dapat menjadi wadah pengisian survei yang tersebar melalui media sosial dan memfasilitasi pengisian secara offline.</p>
              <a href="https://survei.jakarta.go.id/" target="_blank" style="text-decoration: none;" hidden><button class="button-survei">Survei Yang Sedang Berjalan</button></a>
              <div class="row">
                <div class="col-sm-8">                     
                  <div class="chart-container">    
                    <h6><i class="fa fa-user-o icon-chart-title"></i>Jumlah Pengguna Jaksurvei</h6>  
                    <div>                              
                      <Line
                        id="chartJaksurvei"
                        :data="chartData" :options="chartOptions" :plugins="plugins"
                        :height="300"
                      />      
                    </div>            
                  </div>            
                </div>
                <div class="col-sm-4">
                  <div class="card-container">    
                    <div class="row">              
                      <div class="col-sm-12 col-sm-6 wrapper-count-jaksurvei-top">  
                        <h6><i class="fa fa-suitcase icon-count-jaksurvei"></i>Jumlah OPD yang Bekerjasama</h6>  
                        <h1 class="title-count-jaksurvei">35</h1>   
                      </div>            
                      <div class="col-sm-12 wrapper-count-jaksurvei-bottom">  
                        <h6><i class="fa fa-list icon-count-jaksurvei"></i>Jumlah Survei yang Dijalankan</h6>  
                        <h1 class="title-count-jaksurvei">80</h1>   
                      </div>            
                    </div>           
                  </div>           
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
    
  <script>

import { Chart as ChartJS,
            CategoryScale,
            LinearScale,
            PointElement,
            LineElement,
            Title,
            Tooltip,
            Legend,
        } from 'chart.js'
            
  import { Line } from 'vue-chartjs'

  ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend,
    )

  export default {
    name: 'BannerJaksurvei',
    components: {
      Line
    },
    data(){
      return{
        backgroundStyle:null,
        qSearch:'',
        imagesUrl: require('@/assets/misc/peta-indonesia.jpg'),
        chartData: {
            labels: ['2019', '2020', '2021', '2022','2023','2024'],
            datasets: [
                {
                  label: 'Jumlah Pengunjung Jaksurvei',
                  backgroundColor: '#fb8c00',
                  borderColor: '#fb8c00',
                  data: [193160,666074,1204737,1386184,2417632,3051494],
                  pointRadius: 1,
                  fill: true
                },
            ]
        },
        chartOptions: {
          scales:{
              y: {
                  display: false ////this will remove all the x-axis grid lines
              },
              x : {
                grid: {
                  display: false,                 
                }
              }
          },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            intersect: false
          },
          plugins: {
            id: 'customCanvasBackgroundColor',
            beforeDraw: (chart, args, options) => {
              const {ctx} = chart;
              ctx.save();
              ctx.globalCompositeOperation = 'destination-over';
              ctx.fillStyle = options.color || '#99ffff';
              ctx.fillRect(0, 0, chart.width, chart.height);
              ctx.restore();
            },
            legend: {
              display: false,
              labels: {
                // color: 'rgb(255, 99, 132)'
              },
              align: 'start',
              padding: 0
            },
            title: {
                display: false,
                align: 'center',
                text: 'Jumlah Pengunjung Jaksurvei',
                padding: {
                    top: 10,
                    bottom: 30
                },
                font: {
                    size: 14,
                    weight: 'bold'
                }
            }
        }
        },        
      }
    },
    mounted(){

     
        
      // this.backgroundStyle = {
      //   background: `-webkit-linear-gradient(rgb(0 54 90 / 0%), rgb(0 54 90 / 0%)), url(${this.imagesUrl})`,
      //   backgroundSize:'cover'
      // }
    },
    methods:{

    }
  }
  </script>
    